import { BasicFrame } from 'components/organisms';
import { BrokenLink, FourOhFour, Shadow } from 'components/icons';
import { ButtonActor, Heading, Text } from 'components';
import { frameConfigBasic } from '../../AppConfig';
import { getScreenTranslation } from '../../utils/translations';
import {
  LOGIN_ROUTE,
  LOGIN_VIVUS_ONLINE_PATH,
  LOGIN_VIVUS_PATH,
} from '../../utils/constants';
import { logout } from '../../actions/logout';
import { routes } from '../../routes';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classes from 'classnames';
import layout from 'scss/layout.module.scss';
import Loader from 'components/Loader/Loader';
import React, { useEffect } from 'react';
import styles from './NotFound.module.scss';

export default function NotFound() {
  const navigate = useNavigate();
  const i18Next = useTranslation();
  const { pathname } = useLocation();

  const isLoginRoute = [LOGIN_VIVUS_PATH, LOGIN_VIVUS_ONLINE_PATH].includes(
    pathname,
  );

  useEffect(() => {
    if (isLoginRoute) {
      logout(LOGIN_ROUTE);
    }
  }, [pathname]);

  if (isLoginRoute) return <Loader />;

  const { title, subtitle, buttonText } = getScreenTranslation(
    'notFound',
    i18Next,
  );

  return (
    <BasicFrame {...frameConfigBasic} hideBack hideLogout>
      <div className={styles.main}>
        <div className={styles.graphics}>
          <BrokenLink
            style={{
              position: 'absolute',
              transform: 'translate(-70px, -70px)',
            }}
          />
          <FourOhFour />
          <Shadow
            style={{
              bottom: '0',
            }}
          />
        </div>

        <Heading
          dataTest="notFound-heading"
          text={title}
          level="h1"
          weight="medium"
          className={styles.title}
        />

        <Text
          dataTest="notFound-subtitle"
          kind="span"
          level={2}
          text={subtitle}
          className={styles.subtitle}
        />

        <ButtonActor
          buttonProps={{
            className: styles.button,
            dataTest: 'notFound-button',
            onClick: () => navigate(routes.FirstLoan),
          }}
          className={classes(styles.center, layout['width-sm'])}
        >
          {buttonText}
        </ButtonActor>
      </div>
    </BasicFrame>
  );
}
